module.exports = __webpack_public_path__ + "static/media/STHiFi4.97ac4007.png";